/* eslint-disable jsx-a11y/anchor-is-valid */
import { Col, Row } from 'antd';
import { omit } from 'lodash';
import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import { EmailConfig, EmailConfigBase } from 'api/account';
import { SettingsLabel } from '../../styles';
import { EmailConfigs } from './email-configs';
import { Header } from './header';
import { Table } from './table';

const transformConfig = (config: EmailConfig) => {
  const transformedConfig = {
    ...config,
    data: [config.spf, config.dkim1, config.dkim2].filter(Boolean),
  };

  return omit(transformedConfig, ['spf', 'dkim1', 'dkim2']);
};

export const DomainDetails: FC<{
  config: EmailConfig;
  onDelete: (emailDomain: string) => void;
  onVerify: (emailDomain: string) => void;
  onUpdate: (data: EmailConfigBase) => void;
  loading: boolean;
}> = ({ config, onDelete, loading = false, onVerify, onUpdate }) => {
  if (!config) {
    return null;
  }

  const trandformedConfig = transformConfig(config);

  return (
    <>
      <Row gutter={[0, 20]}>
        <Col span={24}>
          <SettingsLabel>
            <FormattedMessage id="settings.email_configuration.details.title" />
          </SettingsLabel>
        </Col>
        <Col span={24}>
          <SettingsLabel>
            <FormattedMessage id="configure_dkim" />
          </SettingsLabel>
          <FormattedMessage id="settings.email_configuration.details.paragraph" />
        </Col>
        <Col span={24}>
          <Row gutter={[16, 24]}>
            <Col span={24}>
              <Header
                config={trandformedConfig}
                onDelete={onDelete}
                loading={loading}
                onVerify={onVerify}
              />
            </Col>
            <Col span={24}>
              <Table data={trandformedConfig.data} />
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <EmailConfigs
            config={trandformedConfig}
            onUpdate={onUpdate}
            loading={loading}
          />
        </Col>
      </Row>
    </>
  );
};
